import React from 'react';
import SEOHead from '../../components/seo/SEOHead';
import { motion } from 'framer-motion';

const Disclaimer = () => {
  return (
    <>
      <SEOHead
        title="Disclaimer"
        description="Important disclaimers and limitations regarding the use of Animatronic Database."
      />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-3xl font-bold text-content-primary mb-8">Disclaimer</h1>
          
          <div className="prose prose-invert max-w-none space-y-6">
            <p className="text-content-secondary">Effective Date: 01/13/2025</p>
            The content on Animatronic Database is provided for informational purposes only.

            <section>
              <h2>1. Information Accuracy</h2>
              <p>
                 While we strive to ensure accuracy, we cannot guarantee that all content (including user submissions) is free of errors or omissions.
              </p>
            </section>

            <section>
              <h2>2. Copyright Attribution</h2>
              <p>
                We do not claim ownership of user-submitted content or sourced images and videos. Credit is provided to the original creators where possible.
              </p>
            </section>

            <section>
              <h2>3. Limitation of Liability</h2>
              <p>
                Animatronic Database is not liable for any damages arising from the use of our site.
              </p>
            </section>

            <section>
              <h2>4. Contact Information</h2>
              <p>
                For questions about this disclaimer, please contact{' '}
                <a href="mailto:legal@animatronicdatabase.com" className="text-brand hover:text-brand-light">
                  legal@animatronicdatabase.com
                </a>
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default Disclaimer;